import { render, staticRenderFns } from "./worksOnParcels.vue?vue&type=template&id=4afb948d"
import script from "./worksOnParcels.vue?vue&type=script&lang=js"
export * from "./worksOnParcels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports